import React, { useEffect, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Logout, LoginData } from "../../redux/featuer/user/userSlice";
import PageChange from "../../pageChange/index";
import toast from "react-hot-toast";

export default function Auth({ isHeader }) {
    const dispatch = useDispatch();
    const { token, login } = useSelector((item) => item.user);
    const [isDataLoad, setIsDataLoad] = useState(true)
    const [changeUrl, setChangeUrl] = useState(true)

    const getUser = useCallback(async (token) => {
        try {
            const res = await fetch(`${process.env.REACT_APP_SERVER}/api/user/me/`, {
                method: "GET",
                headers: {
                    Authorization: "ArNew " + token,
                },
            });

            const result = await res.json();

            if (!result.data) {
                dispatch(Logout());
                toast.error("شما دسترسی ندارید");
                window.location.href = '/';
                return;
            }

            if (result.status === "success") {
                if (result.data?.status === 0) {
                    setChangeUrl(false)
                    setTimeout(() => {
                        dispatch(Logout());
                        window.location.href = '/register?phone=' + result.data.phone;
                    }, 500);
                } else {
                    dispatch(LoginData(result.data));
                    if (isHeader) {
                        setIsDataLoad(false)
                    } else {
                        window.location.href = '/';
                    }
                }
            } else {
                toast.error(result.msg);
                dispatch(Logout());
                window.location.href = '/';
            }
        } catch (error) {
            console.log(error);
        }
    }, [dispatch, token]);


    useEffect(() => {
        if (!login) {
            if (changeUrl) {
                window.location.href = "/login";
            }
        } else {
            getUser(token);
        }
    }, [login, getUser, token]);


    return (
        <>
            {isDataLoad ?
                (
                    <PageChange />
                ) : (
                    null
                )
            }
        </>
    );
}